import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  IMomentDenormalized,
  MomentInstanceStatus,
  PARTICIPANT_ACTOR_KEY,
  SubTaskQuestionAnswerAddress,
  SubTaskQuestionAnswerLinearScale,
  SubTaskQuestionAnswerMultiSelect,
  SubTaskQuestionAnswerRating,
  SubTaskQuestionAnswerSelect,
  SubTaskQuestionAnswerSupportingActor,
  SubTaskQuestionAnswerText,
  SubTaskType,
  SwagUpChoiceAnswerData,
  TaskStatus
} from '@dadohr/shared/domainTypes/experience';
import { ISubmitFileMonitor } from '@dadohr/shared/domainTypes/submitFileMonitor';
import { Page } from '../../../../layout/Page';
import { PageBody } from '../../../../layout/PageBody';
import { SubTaskContext, Task } from '../../Experience/components/Task';
import { TopBanner } from '../../Experience/components/TopBanner';
import {
  answerMomentSubTask,
  answerMomentSubTasks,
  completeMomentSubTask,
  getMomentSubTaskVisitUrl,
  trackMomentSubTaskCompletion
} from '../service';

function getTaskStatusFromMomentStatus(
  status: MomentInstanceStatus
): TaskStatus {
  switch (status) {
    case MomentInstanceStatus.OPEN:
      return TaskStatus.RUNNING;
    case MomentInstanceStatus.PENDING:
      return TaskStatus.NOT_STARTED;
    case MomentInstanceStatus.COMPLETED:
      return TaskStatus.COMPLETE;
    case MomentInstanceStatus.ERROR:
      return TaskStatus.COMPLETE;
  }
}

export const StandaloneAppPageMomentOverviewInner = ({
  moment,
  showTopBanner,
  isPreview
}: {
  moment: Doc<IMomentDenormalized>;
  showTopBanner?: boolean;
  isPreview?: boolean;
}) => {
  const m = moment.data;

  const subTaskContext: SubTaskContext = {
    tz: m.org.tz,
    user: m.user,
    userId: m.userId,
    answerSubTask: function (
      subTaskId: string,
      value:
        | SubTaskQuestionAnswerText
        | SubTaskQuestionAnswerAddress
        | SubTaskQuestionAnswerSelect
        | SubTaskQuestionAnswerMultiSelect
        | SwagUpChoiceAnswerData
        | SubTaskQuestionAnswerSupportingActor
        | SubTaskQuestionAnswerLinearScale
        | SubTaskQuestionAnswerRating
    ): Promise<any> {
      return answerMomentSubTask(m.instanceId, {
        subTaskId,
        d: value
      });
    },
    answerSubTasks: function (
      answers: {
        subTaskId: string;
        d:
          | SubTaskQuestionAnswerText
          | SubTaskQuestionAnswerAddress
          | SubTaskQuestionAnswerSelect
          | SubTaskQuestionAnswerMultiSelect
          | SwagUpChoiceAnswerData
          | SubTaskQuestionAnswerSupportingActor
          | SubTaskQuestionAnswerLinearScale
          | SubTaskQuestionAnswerRating;
      }[]
    ): Promise<any> {
      return answerMomentSubTasks(m.instanceId, answers);
    },
    completeSubTask: (subTaskId: string) => {
      return completeMomentSubTask(m.instanceId, subTaskId).then(() => ({}));
    },

    getSubTaskVisitUrl: function (subtaskId: string, url: string): string {
      return getMomentSubTaskVisitUrl(url, m.instanceId, subtaskId);
    },
    submitFileMonitorId: (subTaskId: string) => {
      throw new Error('Function not Implemented');
    },
    constructNextFileSubmitMonitor: function (
      file: File,
      subTaskId: string
    ): ISubmitFileMonitor {
      throw new Error('Function not Implemented');
    },
    trackSubTaskCompletion: (subTaskId: string, subTaskType: SubTaskType) => {
      return trackMomentSubTaskCompletion(m.instanceId, subTaskId, subTaskType);
    },
    answerComplexSubtask: function (
      subtaskId: string,
      value:
        | SubTaskQuestionAnswerText
        | SubTaskQuestionAnswerAddress
        | SubTaskQuestionAnswerSelect
        | SubTaskQuestionAnswerMultiSelect
        | SwagUpChoiceAnswerData
        | SubTaskQuestionAnswerSupportingActor
        | SubTaskQuestionAnswerLinearScale
        | SubTaskQuestionAnswerRating
    ): Promise<any> {
      throw new Error('Function not implemented.');
    },
    trackEvent: () => null
  };

  return (
    <PageBody noTopPadding noSidePadding={isPreview}>
      <Page width="M">
        {showTopBanner && (
          <TopBanner
            d={{
              firstName: m.user.preferredName,
              salutation: `Hi ${m.user.preferredName}!`,
              actor: PARTICIPANT_ACTOR_KEY,
              orgName: m.org.name,
              title: m.subject
            }}
          />
        )}
        <Task
          taskId=""
          context={{
            title: moment.data.subject,
            status: getTaskStatusFromMomentStatus(moment.data.status),
            startDate: moment.data.sendAt,
            endDate: null,
            completedAt: null,
            completionCriteria: moment.data.content.customCompletionCriteria,
            subtasks: moment.data.content.blocks,

            org: moment.data.org,
            user: moment.data.user,
            userId: moment.data.userId,

            subTaskContext: subTaskContext,
            additionalInfo: null,
            customHints: null
          }}
          variant="expanded"
        />
      </Page>
    </PageBody>
  );
};
